import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {KeyMap} from "../../../../_typing/generic-types";
import {Field, FieldMap, Rule} from "../../../../_typing/query-builder";
import {BaseComponent} from "../../../../shared/base.component";
import {QueryBuilderFormService} from "../../../../services/query-builder-form.service";
import {COMMON_FORM_IMPORTS} from "../../../../shared/import-groups/Common";
import {SelectFilterComponent} from "../../../select-filter/select-filter.component";
import {DateTimePickerComponent} from "../../../../date-time/date-time-picker/date-time-picker.component";


@Component({
    selector: 'wire-query-value',
    templateUrl: './wire-query-value.component.html',
    imports: [
        COMMON_FORM_IMPORTS,
        SelectFilterComponent,
        DateTimePickerComponent
    ],
    styleUrls: ['./wire-query-value.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class WireQueryValueComponent extends BaseComponent {

    private _operator: string;
    @Input() set operator(operator: string) {
        this._operator = operator;
        if (operator) {
            this.compareBlank = this.operatorDesc?.[operator]?.toLowerCase().includes('blank');
        }
    };

    get operator(): string {
        return this._operator;
    }

    @Input() rule: Rule;
    @Input() readonly fields: FieldMap;
    @Output() valueChanged: EventEmitter<void> = new EventEmitter();
    @Input() selectedField: Field;

    operatorDesc: KeyMap<string>;
    compareBlank: boolean

    constructor(private queryBuilderFormService: QueryBuilderFormService) {
        super();
    }

    ngOnInit() {
        this.operatorDesc = this.queryBuilderFormService.operatorDesc;
        if (this.operator) {
            this.compareBlank = this.operatorDesc[this.operator]?.toLowerCase().includes('blank');
        }
    }
}
